import { createBrowserRouter, Navigate } from 'react-router';

import ErrorFallback from '@/App/ErrorFallback';
import ProtectedRoute from '@/components/ProtectedRoute';
import RootLayout from '@/App/RootLayout';

import Login from '@/App/Authentication/Login';
import Registration from '@/App/Authentication/Registration';
import ForgotPassword from '@/App/Authentication/ForgotPassword';
import NewPassword from '@/App/Authentication/NewPassword';
import ConfirmEmail from '@/App/Authentication/ConfirmEmail';
import Dashboard from '@/App/Dashboard';
import Calendar from '@/App/Calendar';
import AgendasMain from '@/App/Agendas/Main';
import AgendasDetails from '@/App/Agendas/Details';
import AgendasAcceptInvite from '@/App/Agendas/AcceptInvite';
import AgendasEventDetails from '@/App/Events/Details';

export const router = createBrowserRouter([
  {
    Component: RootLayout,
    errorElement: <ErrorFallback />,
    children: [
      { path: '/', Component: Login },
      { path: '/cadastro', Component: Registration },
      { path: '/esqueci-senha', Component: ForgotPassword },
      { path: '/nova-senha/:token', Component: NewPassword },
      { path: '/confirmar-email/:token', Component: ConfirmEmail },
      {
        Component: ProtectedRoute,
        children: [
          {
            path: '/painel',
            Component: Dashboard,
            children: [
              {
                index: true,
                element: <Navigate to="/painel/agendas" replace />,
              },
              {
                path: 'agendas',
                children: [
                  {
                    index: true,
                    Component: AgendasMain,
                  },
                  {
                    path: ':agendaId',
                    Component: AgendasDetails,
                  },
                  {
                    path: ':agendaId/evento/:eventId',
                    Component: AgendasEventDetails,
                  },
                  {
                    path: 'aceitar-convite/:token',
                    Component: AgendasAcceptInvite,
                  },
                ]
              },
              {
                path: 'calendario',
                Component: Calendar,
              },
            ],
          },
        ],
      },
    ],
  },
]);
